import { render } from "./AppBarForceRefreshButton.vue?vue&type=template&id=896028fc&scoped=true"
import script from "./AppBarForceRefreshButton.vue?vue&type=script&lang=js"
export * from "./AppBarForceRefreshButton.vue?vue&type=script&lang=js"

import "./AppBarForceRefreshButton.vue?vue&type=style&index=0&id=896028fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-896028fc"]])

export default __exports__